import { useState } from 'react';
import { InputFieldContainerProps } from '../common/InputFieldContainer';
import PasswordField from '../common/PasswordField';
import PasswordRequirementsChecklist from './PasswordRequirementsChecklist';
import { useWidgetContext } from '../context/WidgetContext';
import { isAnetUser } from '../../utils/user-utils';
export default function PasswordSection(props: InputFieldContainerProps) {
  const [ password, setPassword ] = useState('');
  const { controller } = useWidgetContext();
  const isNonAnetUserOnPasswordExpiryScreen = controller === 'password-expired' && !isAnetUser();
  return (
    <>
      {isNonAnetUserOnPasswordExpiryScreen ? (
        <>
          <PasswordField
            {...props}
            doMoreOnChange={(event: React.ChangeEvent<HTMLInputElement>) => setPassword(event.target.value)}
          />
          {<PasswordRequirementsChecklist password={password} />}
        </>
      ) : (
        <PasswordField {...props} />
      )}
    </>
  );
}
